export default __webpack_public_path__ + "static/media/030-binoculars.97b934e6.png";